import { useDispatch, useSelector } from 'react-redux';

import './CreateUserForm.css';

import { changeNewUserRole, changeNewUserName, changeNewUserId, createUserFormIsActive, selectCreateUserFormBranch, selectCreateUserFormName, selectCreateUserFormUserId, selectCreateUserFormUserRole, changeNewUserBranch, toggleCreateUserForm, clearCreateUserForm, changeStatus, createUserStatus, createUser, creatingNewUser, selectConfirmingCreateUser, setCreateUserConfirming } from './createUserFormSlice';
import { addUser } from '../manageUsers/manageUsersSlice';
import { selectBranches } from '../manageBranches/branchesSlice';
import ConfirmAction from '../../components/confirmAction/ConfirmAction';
import { selectUser } from '../home/userSlice';
import { selectToken } from '../login/loginSlice';

export default function CreateUserForm() {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const activeCreateForm = useSelector(createUserFormIsActive);
    const branches = useSelector(selectBranches);
    const newUserId = useSelector(selectCreateUserFormUserId);
    const newUserName = useSelector(selectCreateUserFormName);
    const newUserRole = useSelector(selectCreateUserFormUserRole);
    const newUserBranch = useSelector(selectCreateUserFormBranch);
    const confirmingCreateUser = useSelector(selectConfirmingCreateUser);
    const statusMessage = useSelector(createUserStatus);
    const creatingUser = useSelector(creatingNewUser);

    const userInfo = useSelector(selectUser);
    const bankId = userInfo.bankId;

    const display = activeCreateForm ? "flex" : "none";

    const handleNewUserIdChange = (event) => {
        dispatch(changeNewUserId(event.target.value));
    }
    
    const handleNewUserNameChange = (event) => {
        dispatch(changeNewUserName(event.target.value));
    }

    const handleNewUserRoleChange = (event) => {
        dispatch(changeNewUserRole(event.target.value));
    }

    const handleNewUserBranch = (event) => {
        dispatch(changeNewUserBranch(event.target.value));
    }
    
    const handleCancelButtonClick = (event) => {
        event.preventDefault();
        dispatch(toggleCreateUserForm());
        dispatch(clearCreateUserForm());
    }

    const handleCreateUserButtonClick = (event) => {
        event.preventDefault();
        
        if (!newUserId || !newUserName) {
            dispatch(changeStatus("Please provide a User Id and Name"));
        } else if (newUserRole === 'User' && !newUserBranch) {
            dispatch(changeStatus('Student accounts must be assigned to a branch'));
        } else {
            dispatch(setCreateUserConfirming(true));
        }
    }

    const handleCancelConfirmClick = () => {
        dispatch(setCreateUserConfirming(false));
    }

    const handleConfirmClick = () => {

        const newUser = {
            username: newUserId,
            password: 'password',
            name: newUserName,
            userRole: newUserRole,
            bankId: bankId,
            branchId: newUserRole === 'USER' ? newUserBranch : ''
        }

        dispatch(createUser({newUser, token}));
        dispatch(addUser(newUser));
        dispatch(clearCreateUserForm());
        dispatch(setCreateUserConfirming(false));
    }

    return (
        <form className='form' style={{display:display, flexDirection:'column'}}>
            <h3>Create User</h3>
            <label htmlFor='userId'>
                User Id:
                <input value={newUserId} onChange={handleNewUserIdChange}></input>
            </label>
            <label htmlFor='name'>
                Name:
                <input value={newUserName} onChange={handleNewUserNameChange}></input>
            </label>
            <label htmlFor='userRole'>
                User Role:
                <select value={newUserRole} onChange={handleNewUserRoleChange}>
                    <option value={'ADMIN'}>Admin</option>
                    <option value={'TELLER'}>Teller</option>
                    <option value={'USER'}>Student</option>
                </select>
            </label>
            {newUserRole !== 'USER' ? "" : (
                <label htmlFor='branch'>
                    Branch:
                    <select value={newUserBranch} onChange={handleNewUserBranch}>
                        <option key="blank" value="blank">- select -</option>
                        {branches.map(branch => <option key={branch.branchId} value={branch.branchId}>{branch.branchName}</option>)}
                    </select>
                </label>
            )}
            {!statusMessage ? "" : 
                <p className={statusMessage === 'Successfully created user' ? 'confirmation' : 'error'}>{statusMessage}</p>
            }
            <div className='button-container'>
                <button onClick={handleCancelButtonClick} disabled={creatingUser}>Cancel</button>
                <button onClick={handleCreateUserButtonClick} disabled={creatingUser}>{creatingUser ? "Creating New User..." : "Create New User"}</button>
            </div>
            {confirmingCreateUser ? <ConfirmAction handleCancel={handleCancelConfirmClick} handleConfirm={handleConfirmClick}/> : ""}
        </form>
    )
}